import { makeStyles } from "tss-react/mui";
const useStyles = makeStyles()((theme, { width = 668 })=>({
        dialogPaper: {
            overflowY: 'auto',
            minHeight: 'auto',
            borderRadius: theme.tokens.radius.l,
            flexGrow: 1,
            [theme.breakpoints.up('md')]: {
                minWidth: theme.px(width)
            },
            '& > form': {
                display: 'flex',
                flexDirection: 'column',
                flex: 1
            }
        },
        bottomIslandSpace: {
            marginBottom: theme.px(120)
        },
        dialogWithoutRadius: {
            borderRadius: 0
        }
    }));
export { useStyles };
